import { Router } from '@angular/router';;
import { NgZone, Component, OnInit } from '@angular/core';
import { PushService, TOPIC_NEW_CONTACT_MESSAGE } from 'src/app/services/push.service';
import { DBService } from 'src/app/services/db.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit {

  message: string = "";
  contact: string = "";

  constructor(private db: DBService, private ngZone: NgZone, private router: Router, private pushService:PushService, public util:UtilService) { }

  ngOnInit() {
  }

  back() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))

      return
    }
    if (!this.db.loggedUserUID || !(this.db.isOwner || this.db.isEmployee)) this.ngZone.run(() => this.router.navigate(['/customer-home']))
    else this.ngZone.run(() => this.router.navigate(['/owner-home']))
  }

  sendMessage() {
    this.pushService.sendPush("Neue Nachricht von "+(this.db.loggedUserUID?this.db.loggedUserUID:'Unbekannt'), this.message + " (Rückmeldung an "+this.contact+")", TOPIC_NEW_CONTACT_MESSAGE, 'BARELA_MSG').subscribe((val: any) => {
      this.db.sendMessage(new Date().toLocaleString()+": "+this.message + " (Von: "+(this.db.loggedUserUID?this.db.loggedUserUID:'Unbekannt')+" / Rückmeldung an "+this.contact+")")
      this.util.presentToast('Vielen Dank für deine Nachricht - Wir bearbeiten diese so schnell wie möglich', 4000, 'toast-success')
      this.back();
    },err => {
      this.util.presentToast("Entschuldigung, da hat etwas nicht funktioniert.", 4000, 'toast-warning')
      this.util.error("err sendMessage",JSON.stringify(err))
    })
   
  }

}
